import {Box} from '@chakra-ui/react';

export const GreenCircleIcon = () => (
  <Box bg={'brand.green'} h={'14px'} w={'14px'} borderRadius={'14px'} />
);
